import Button from 'components/base/Button';
// import AuthSocialButtons from 'components/common/AuthSocialButtons';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import authenticationService from 'services/authentication';
import { useState } from 'react';
//mport SignIn from 'pages/pages/authentication/simple/SignIn';
// import { error } from 'console';

const SignUpForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  // create a new user by sending a POST request to the API using services/authentication.js signUpNewUser
  const [modalShow, setModalShow] = useState(false);
  const [errorModalShow, setErrorModalShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [email, setEmail] = useState('');
  const [isTermsChecked, setIsTermsChecked] = useState(false);

  const handleTermsCheckChange = () => {
    setIsTermsChecked(!isTermsChecked);
  };

  const validateEmail = (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    setIsValidEmail(validateEmail(newEmail));
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    setPasswordsMatch(e.target.value === confirmPassword);
  };

  const handleConfirmPasswordChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setConfirmPassword(e.target.value);
    setPasswordsMatch(password === e.target.value);
  };

  const handleSignUp = () => {
    const firstName = document.getElementById('firstname') as HTMLInputElement;
    const lastName = document.getElementById('lastname') as HTMLInputElement;
    const email = document.getElementById('email') as HTMLInputElement;
    const password = document.getElementById('password') as HTMLInputElement;
    const userName = document.getElementById('username') as HTMLInputElement;

    authenticationService
      .signUpNewUser(
        firstName.value,
        lastName.value,
        email.value,
        password.value,
        userName.value
      )
      .then(() => {
        // Handle the response here
        setModalShow(true);
      })
      .catch(error => {
        // Handle the error here
        setErrorModalShow(true);
        setErrorMsg(error.response.data);
        console.log('Sign Up Error:', error);
      });
  };
  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-1000">Sign Up</h3>
        <p className="text-700">Create your account today</p>
      </div>
      {/* <AuthSocialButtons title="Sign up" /> 
      <div className="position-relative mt-4">
        <hr className="bg-200" />
        <div className="divider-content-center">or use email</div>
      </div>*/}
      <Form>
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="username"></Form.Label>
          <Form.Control id="username" type="text" placeholder="UserName" />
        </Form.Group>
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="firstname"></Form.Label>
          <Form.Control id="firstname" type="text" placeholder="First name" />
        </Form.Group>
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="lastname"></Form.Label>
          <Form.Control id="lastname" type="text" placeholder="Last name" />
        </Form.Group>
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="email"></Form.Label>
          <Form.Control
            id="email"
            type="email"
            value={email}
            placeholder="name@example.com"
            onChange={handleEmailChange}
          />
        </Form.Group>
        <Row className="g-3 mb-3">
          <Col sm={layout === 'card' ? 12 : 6} lg={6}>
            <Form.Group>
              <Form.Label htmlFor="password"></Form.Label>
              <Form.Control
                id="password"
                type="password"
                placeholder="Password"
                value={password}
                onChange={handlePasswordChange}
              />
            </Form.Group>
          </Col>
          <Col sm={layout === 'card' ? 12 : 6} lg={6}>
            <Form.Group>
              <Form.Label htmlFor="confirmPassword"></Form.Label>
              <Form.Control
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                placeholder="Confirm Password"
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Check type="checkbox" className="mb-3">
          <Form.Check.Input
            type="checkbox"
            name="termsService"
            id="termsService"
            onChange={handleTermsCheckChange}
          />
          <Form.Check.Label htmlFor="termsService" className="fs-9 text-none">
            I accept the <Link to="#!">terms </Link>and{' '}
            <Link to="#!">privacy policy</Link>
          </Form.Check.Label>
        </Form.Check>
        <Button
          variant="primary"
          disabled={!passwordsMatch || !isValidEmail || !isTermsChecked}
          className="w-100 mb-3"
          onClick={handleSignUp}
        >
          Sign up
        </Button>
        <div className="text-center">
          <Link
            to={`/pages/authentication/${layout}/sign-in`}
            className="fs-9 fw-bold"
          >
            Sign in to an existing account
          </Link>
        </div>
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Swoosh!
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>We just sent you a confirmation email</h4>
            <p>
              Follow the instructions in the email to complete your registration
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setModalShow(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={errorModalShow}
          onHide={() => setErrorModalShow(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Oops!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>There is an issue with the details entered</h4>
            <p>
              {errorMsg}. You can reset your password{' '}
              <a href="/pages/authentication/split/sign-in">here</a> or close
              this message and try again.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setErrorModalShow(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </Form>
    </>
  );
};

export default SignUpForm;
